const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "brand":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "brand",
    reducer: reducer,
};

export default data;